import { render, staticRenderFns } from "./query-header-form.vue?vue&type=template&id=23dcbde2&"
import script from "./query-header-form.vue?vue&type=script&lang=ts&"
export * from "./query-header-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports